import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { CONTACT, SOCIAL_PROOF } from '../data/site';
const NOTIFICATION_INTERVAL = 28_000;
const DISPLAY_DURATION = 8_000;
const FIRST_DELAY = 6_000;
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const firstTimer = setTimeout(() => setIsVisible(true), FIRST_DELAY);
    const interval = setInterval(() => {
      setIndex(value => (value + 1) % SOCIAL_PROOF.length);
      setIsVisible(true);
    }, NOTIFICATION_INTERVAL);
    return () => {
      clearTimeout(firstTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  useEffect(() => {
    if (!isVisible) return;
    const timer = setTimeout(() => setIsVisible(false), DISPLAY_DURATION);
    return () => clearTimeout(timer);
  }, [isVisible, index]);
  const current = SOCIAL_PROOF[index];
  return <AnimatePresence data-id="element-230" data-mp="8c84pzkevx1d">
      {isVisible && !dismissed && <motion.aside initial={{
      opacity: 0,
      x: -24,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -24,
      y: 12
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} aria-live="polite" className="fixed bottom-20 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:max-w-sm" data-id="element-231" data-mp="8e1a7bjagb7s">
          <div className="flex items-start gap-3 rounded-2xl border border-ink-line bg-ink-card/95 p-4 pr-10 shadow-2xl shadow-black/60 backdrop-blur" data-id="element-232" data-mp="r9rfp8qfjpqf">
            <img src={CONTACT.logo} alt="Leal 11 Sports logo" className="h-10 w-10 shrink-0 rounded-full object-cover ring-1 ring-white/20" data-id="element-233" data-mp="1541yzajnqrp3" />
            <div data-id="element-234" data-mp="1ey0s5k1r714w">
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-235" data-mp="1a1k7x0xod6x3">
                Someone just joined the {current.plan} in {current.area}!
              </p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-brand-orange" data-id="element-236" data-mp="1h2fe2n5o5ccv">
                A few minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-full text-white/45 transition-colors hover:bg-white/10 hover:text-white" data-id="element-237" data-mp="1r1my1t6ws58y">
              <XIcon className="h-4 w-4" data-id="element-238" data-mp="24w5vrrbwqkkx" />
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}